<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('orderapplications')">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Editar Pedid{{i=0}}
      </h1>
   
    <inertia-link v-if="form.tracking == 'Aprobado'" class="btn-indigo" :href="route('orderapplicationsgestion.edit',order.id)">
        <span>Agregar</span>
        <span class="hidden md:inline">Solicitud</span>
      </inertia-link>
      <inertia-link v-if="form.tracking == 'Pedido' && $page.props.auth.user.rol =='Fiscalizador'" class="btn-indigo" :href="route('orderapplicationsaprobar.edit',order.id)">
        <span>Aprobar</span>
        <span class="hidden md:inline">Solicitud</span>
      </inertia-link>
    </div>
      <br>
      <inertia-link class="btn-indigo" :href="route('orderapplicationarticle.edit',order.id)">
        <span>Agregar</span>
        <span class="hidden md:inline">Artículo</span>
      </inertia-link>
   
      <br>
      <br>
    <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
          Detalle de Productos
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(2)" v-bind:class="{'text-amber-600 bg-white': openTab !== 2, 'text-black bg-amber-600': openTab === 2}">
           Encabezado de Solicitud
          </a>
        </li>
      </ul>
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
              <form @submit.prevent="storeDetail">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
               
              <!--  <div class="container pb-8 pr-6 w-full lg:w-1/6">
                <label class="form-label" >Para:</label>
                <v-select v-model="form.user_id" :options="userss" value="id" label="fullname" required></v-select>
                </div>  -->
                <text-input v-model="form2.ammount" :error="form.errors.ammount" :req="form.ammount" class="pb-8 pr-6 w-full lg:w-1/6" label="Cantidad" required/>
                <div class="container pb-8 pr-6 w-full lg:w-3/6">
                <label class="form-label" >Material:</label>
                <v-select v-model="form2.article_application_id" :options="articless" value="id" label="Articulo" required></v-select>
                </div>
                <text-input v-model="form2.cost" :error="form.errors.cost" :req="form.cost" class="pb-8 pr-6 w-full lg:w-1/6" label="Precio"/>
                
                <text-input v-model="form2.detail" :error="form.errors.detail" :req="form.detail" class="pb-8 pr-6 w-full lg:w-1/6" label="Detalle"/>



              </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form2.processing" class="btn-indigo" type="submit">Agregar</loading-button>
        </div>
              </form>
             

             
            </div>
            <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
              <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <div class="container pb-8 pr-6 w-full lg:w-1/6">
                <label class="form-label" >Para:</label>
                <v-select v-model="form.user_id" :options="userss" value="id" label="fullname" required></v-select>
                </div>  
                <div class="container pb-8 pr-6 w-full lg:w-1/6">
                <label class="form-label" >Empresa:</label>
                <v-select v-model="form.organization_id" :options="organizationss" value="id" label="tradename" required></v-select>
                </div>  
                <div class="container pb-8 pr-6 w-full lg:w-1/6">
                <label class="form-label" >Proyecto:</label>
                <v-select v-model="form.project_id" :options="projectss" value="id" label="name" required></v-select>
                </div>  
                <div class="container pb-8 pr-6 w-full lg:w-3/6">
                <label class="form-label" >Activo:</label>
                <v-select v-model="form.machinery_id" :options="machineryss" value="id" label="name" required></v-select>
                </div>  
                
                <textarea-input v-model="form.observation" :error="form.errors.observation" :req="form.observation" class="pb-8 pr-6 w-full lg:w-4/6" label="Observación" />
                <text-input v-model="form.total" :error="form.errors.total" :req="form.total" class="pb-8 pr-6 w-full lg:w-2/6" label="Total Factura" disabled/>

          
              </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Enviar Correo y Guardar</loading-button>
        </div>
              </form>
            </div>
            <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
            
            </div>

            
          </div>
        </div>
       
      </div>
    </div>
  </div>
  <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <div class="flex flex-col">
    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block py-2 min-w-full sm:px-6 lg:px-8">
            <div class="overflow-hidden shadow-md sm:rounded-lg">
          <table class="min-w-full">
        <thead class="bg-gray-50 dark:bg-gray-700">
                        <tr>
                          <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                             Nº
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Cantidad
                            </th>
                          
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                               Material
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Precio
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              IVA
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Subtotal
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                               Detalle
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      
    <tr v-for="detalle in order_details" :key="detalle.id" class="py-3 px-6 bg-white border-b dark:bg-gray-800 dark:border-gray-700">
         <td class="px-6 py-3 flex items-center">
             {{ i=i+1}}
          </td>
          <td>
             {{ detalle.amount }}
          </td>
         
          <td>
              {{ detalle.articleapplication.name }}
          </td>
          <td>
              {{ detalle.cost }}
          </td>
          <td>
              {{ detalle.iva }} %
          </td>
          <td>
              {{ detalle.total }}
          </td>
          <td>
              {{ detalle.detail }}
          </td>
          <td>
            <inertia-link class="btn-indigo items-center" :href="route('orderapplications.destroydetail', detalle.id)" >
             Eliminar
            </inertia-link>
          </td>
        </tr>
        <tr v-if="order_details.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encuentran datos</td>
        </tr>
       </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
    </div>
 
  </div>
</template>

<script>
import Layout from '@/Shared/LayoutMenu'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TextareaInput from '@/Shared/TextareaInput';




export default {
  metaInfo() {
    return {
      title: `${this.form.id}`,
    }
  },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    vSelect,
    DatePicker,
    TextareaInput,
  },
  layout: Layout,
  props: {
    users: Array,
    organizations: Array,
    projects: Array,
    projects_apple: Array,
    order_details: Array,
    articles: Array,
    order: Object,
    machinerys: Array,


  },
  remember: 'form',
  data() {
    return {
      openTab: 1,
      userss: this.users,
      articless: this.articles,
      projectss: this.projects,
      projects_apples: this.projects_apple,
      organizationss: this.organizations,
      machineryss: this.machinerys,
      form: this.$inertia.form({
        id: this.order.id,
        user_id: this.order.user_id ,
        project_id: this.order.project_id,
        project_apple_id: this.order.project_apple_id,
        organization_id: this.order.organization_id,
        machinery_id: this.order.machinery_id,
        observation: this.order.observation,
        total: '$ '+this.order.total,
        tracking: this.order.tracking,

      }),
      form2: this.$inertia.form({
        id: this.order.id,
        order_application_id: this.order.id,
        article_application_id: null,
        ammount: null,
        detail: null,
        cost: 0.00,
      }),
    }
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    update() {
      this.form.put(this.route('orderapplications.update', this.order.id), {
      })
    },
    storeDetail() {
      this.form2.post('/orderapplicationsdetail')
   },
    destroy() {
      if (confirm('Está seguro de Eliminar esta Solicitud?')) {
        this.$inertia.delete(this.route('applicationbuy.destroy', this.order.id))
      }
    },
    restore() {
      if (confirm('Está seguro de Restaurar esta Solicitud?')) {
        this.$inertia.put(this.route('applicationbuy.restore', this.order.id))
      }
    },
  },
}
</script>